angular.module('admin.subscribers.detail', [
  'resources.AdminGroup',
  'resources.Subscriber',
  'services.formErrors',
  'directives.croppic',
  'security'
]);

angular.module('admin.subscribers.detail').config(["$stateProvider", function($stateProvider) {
  $stateProvider
    .state('admin.subscribers.edit', {
      url: '/edit/:id',
      title: 'Subscriber / Details',
      views: {
        'main@': {
          template: require('./admin-subscriber.tpl.html'),
          controller: 'SubscriberDetailCtrl',
          resolve: {
            userDetails: ["adminResource", "$stateParams", function(adminResource, $stateParams) {
              return adminResource.findSubscriber($stateParams.id);
            }],
            groups: ["AdminGroup", function (AdminGroup) {
              return AdminGroup.query().$promise;
            }]
          }
        }
      }
    });
}]);

angular.module('admin.subscribers.detail').controller('SubscriberDetailCtrl',
  ["$scope", "groups", "Subscriber", "formErrors", "growl", "security", "userDetails", "$location", "Upload", "APP_IMG_URLS", "$uibModal", function($scope, groups, Subscriber, formErrors, growl, security, userDetails, $location, Upload, APP_IMG_URLS, $uibModal) {
    $scope.groups = groups.data;
    $scope.user = userDetails;
    $scope.imgUrl = APP_IMG_URLS.base;
    // console.log( '>>>', userDetails );
    $scope.user.passwordnew = "";

    $scope.submit = function (data) {
      const email = data.email;
      delete data.email;
			data.psw = false;
      if(data.passwordnew){
        data.psw = true;
        data.password = security.createHash(data.passwordnew);
			}
			
			
      var toSubmit = angular.copy(data);

      if (toSubmit.account.groups) {
        toSubmit.account.groups = _.map(toSubmit.account.groups, '_id');
			}
			
			toSubmit.passwordnew = data.passwordnew;

      Subscriber.update(toSubmit, function (result) {
        growl.info('Subscriber Updated!');
        $scope.user.email = email;
      }, formErrors.growlErrors);

    };

    /***/
$scope.$watch('file', function (file) {
    if (!file) return;
    $scope.upload(file);
  });

  /*
  $scope.coverOptions = {
    objW: 500,
    objH: 350,
    cropUrl: '/upload/profile/' + resp.data.filename + '/coverPhoto'
  };

  $scope.avatarOptions = {
    objW: 200,
    objH: 200,
    cropUrl: '/upload/profile/' + resp.data.filename + '/photo'
  };
  */

  // upload on file select or drop
  $scope.upload = function (file) {
    $scope.uploading = true;
    $scope.user.account.avatar = file;
    Upload.upload({
      url: '/api/articles/upload',
      data: {file: file}
    }).then(function (resp) {
      $scope.uploading = false;
      $scope.user.account.avatar = resp.data.filename;
      $scope.groups.image = resp.data.filename;
    }, function (resp) {
      $scope.uploading = false;
      $scope.thumbnail = null;
      console.log('Error status: ' + resp.status);
    }, function (evt) {
      var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
      //console.log('progress: ' + progressPercentage + '% ' + evt.config.groups.file.name);
    });
  };
/*
$('#image-cropper').cropit({
  imageBackground: true,
  imageBackgroundBorderWidth: 15 // Width of background border
});*/

  $scope.$watch('file1', function (file) {
    if (!file) return;
    $scope.upload1(file);
  });

  $scope.generateThumb = function(file, rejFile){
    if(file === null && rejFile === undefined){
      growl.info('Max image size is 10MB!',3);

    }
  }

  // upload on file select or drop
  $scope.upload1 = function (file) {
      $scope.uploading = true;
      $scope.user.account.picture = file;
      Upload.upload({
        url: '/api/articles/upload',
        data: {file: file}
      }).then(function (resp) {
        $scope.uploading = false;
        $scope.user.account.picture =  resp.data.filename;
        $scope.groups.image = resp.data.filename;
      }, function (resp) {
        $scope.uploading = false;
        $scope.thumbnail = null;
        console.log('Error status: ' + resp.status);
      }, function (evt) {
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
        //console.log('progress: ' + progressPercentage + '% ' + evt.config.groups.file.name);
      });

  };

    $scope.delete = function (data) {
      if(!confirm('Are you sure you want to delete this user?')) {
        return;
      }
      Subscriber.delete({id: data._id}, function (result) {
        setTimeout(function () {
          growl.info('User deleted!');
          $location.path('/admin/subscribers');
        }, 1000)
      }, formErrors.growlErrors);
    };
  }]);



// WEBPACK FOOTER //
// ./client/src/app/admin/subscribers/admin-subscriber.js